// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__vanKW","search":"Settings_search__3GZGL","filter":"Settings_filter__Bt2GF"};